import { Component } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { withTranslate } from '../../../core/TenantProvider';
import APEmailPreferenceSectionStyles from './styles/APEmailPreferenceSection.style';
import FormControlLabel from '@mui/material/FormControlLabel';
import classnames from 'classnames';
import APHeading from '../../atoms/APHeading';
import { APCheckbox } from '../../atoms/APInput';
import APMultiSelect from '../../atoms/APMultiSelect';
import { setSelectedEmailPreferences } from '../../../containers/SettingsContainer/utils/setters';
import { TriggerGoogleAnalytics4Tag, TriggerGoogleAnalyticsTag } from '../../../core/utils/GoogleAnalyticTag';
import { GoogleAnalyticTags } from '../../../core/utils/GoogleAnalyticTag/GoogleAnalyticsTags';
import { GoogleAnalytics4Tags } from '../../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags';
import { InitialSettingValues } from '../../../containers/SettingsContainer/SettingsContainer';

interface APEmailPreferenceSectionProps extends WithStyles<typeof APEmailPreferenceSectionStyles> {
    translate: Function,
    values: InitialSettingValues,
    handleChange: Function,
    isSuperUser: boolean
}

class APEmailPreferenceSection extends Component<APEmailPreferenceSectionProps> {
    emailPreferences = {
        optOutOfMarketing: 'settings.email.preferences.marketingemails.label',
        getAccountManagerEmails: 'settings.email.preferences.accountmanager.label',
        getNotificationEmails: 'settings.email.preferences.notificationemails.label'
    };

    render() {
        const {
            classes,
            translate,
            values,
            handleChange,
            isSuperUser
        } = this.props;

        return (
            <>
                <div className={classes.settingsFormSection}>
                    <div className={classes.formSectionHeader}>
                        <APHeading className={classes.formSectionHeading}
                            variant="body1">
                            {translate('settings.email.preferences.details.heading')}
                        </APHeading>
                    </div>
                    <div className={classes.formSectionContent}>
                        <APMultiSelect className={classes.manualInput}
                            label={translate('settings.email.preferences.updates.label')}
                            name="selectedEmailPreferences"
                            onChange={(e) => {
                                e.target.value = setSelectedEmailPreferences(e.target.value);
                                const selectedEmailPreferences = setSelectedEmailPreferences(e.target.value).toString().split(',').pop();

                                TriggerGoogleAnalyticsTag(
                                    GoogleAnalyticTags.eventAction.select,
                                    GoogleAnalyticTags.settings.select.emailPreferences,
                                    { emailPreferences: selectedEmailPreferences }
                                );
                                TriggerGoogleAnalytics4Tag(
                                    GoogleAnalytics4Tags.settings.name,
                                    GoogleAnalytics4Tags.eventAction.select,
                                    GoogleAnalytics4Tags.settings.select.emailPreferences,
                                    { emailPreferences: selectedEmailPreferences }
                                );

                                if (e.target.value.length > 0) {
                                    values.optOutOfMarketing = false;
                                }
                                handleChange(e);
                            }}
                            type="emailPreference"
                            selectedValues={values?.selectedEmailPreferences}
                            value={values?.selectedEmailPreferences}
                            disabled={isSuperUser}
                        >
                        </APMultiSelect>
                    </div>
                </div>
                <div className={classes.settingsFormSection}>
                    <div className={classnames(classes.formSectionContent, classes.emailPreferenceCheckboxSection)}>
                        {Object.entries(this.emailPreferences).map(([key, label]) => (
                            <FormControlLabel
                                key={key}
                                value={values?.[key]}
                                control={<APCheckbox />}
                                name={key}
                                onChange={(e) => {
                                    if (key === 'optOutOfMarketing') {
                                        values.selectedEmailPreferences = [];
                                    }
                                    handleChange(e);
                                }}
                                label={translate(label)}
                            />
                        ))}
                    </div>
                </div>
            </>
        )
    }
}

export default withTranslate(
    withStyles(APEmailPreferenceSectionStyles)(APEmailPreferenceSection)
);